import React, { useEffect } from "react";
import { useAI } from "@/context/AIContext";
import { ChatCircleDots, Compass, MapTrifold } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

/**
 * "Ruta" nav destination — guidance & clarification hub.
 * (Formerly "IA"). Opens the help drawer for a direct conversation.
 */
export default function RutaGuide() {
  const { openDrawer } = useAI();

  useEffect(() => {
    const t = setTimeout(() => openDrawer({ prefill: "" }), 200);
    return () => clearTimeout(t);
  }, [openDrawer]);

  return (
    <div data-testid="page-ruta-guide">
      <header className="mb-8">
        <div className="label-mono text-muted-foreground">Ruta</div>
        <h1 className="display text-5xl md:text-6xl mt-1">Guía y claridad</h1>
        <p className="mt-3 max-w-2xl text-sm text-muted-foreground">
          Aquí obtienes ayuda estratégica, recomendaciones y aclaraciones sobre tu negocio.
          Ruta conoce tu contexto: dónde estás en tu playbook, qué hitos siguen y qué tareas están abiertas.
        </p>
      </header>

      <div className="grid md:grid-cols-2 gap-4 max-w-3xl">
        <div className="brut-card" data-testid="ruta-help-card">
          <div className="flex items-center gap-3 mb-3">
            <ChatCircleDots size={20} weight="fill" />
            <div className="label-mono">Obtener ayuda</div>
          </div>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Haz preguntas específicas sobre tu ruta actual: bloqueos, ideas de marketing, próximos pasos, decisiones.
          </p>
          <button
            className="btn-primary mt-4 w-full flex items-center justify-center gap-2"
            onClick={() => openDrawer({ prefill: "" })}
            data-testid="btn-abrir-ayuda"
          >
            <ChatCircleDots size={14} weight="bold" /> Abrir ayuda
          </button>
        </div>

        <div className="brut-card" data-testid="ruta-brujula-card">
          <div className="flex items-center gap-3 mb-3">
            <Compass size={20} weight="fill" />
            <div className="label-mono">Reevaluar tu ruta</div>
          </div>
          <p className="text-sm leading-relaxed text-muted-foreground">
            ¿Estás pensando en explorar una nueva oportunidad o pivotar? Regresa a la Brújula.
          </p>
          <Link
            to="/brujula"
            className="btn-secondary mt-4 w-full flex items-center justify-center gap-2"
            data-testid="btn-ir-brujula"
          >
            <Compass size={14} weight="bold" /> Ir a la Brújula
          </Link>
        </div>
      </div>

      <div className="brut-card mt-6 max-w-3xl" data-testid="ruta-how-it-works">
        <div className="flex items-center gap-3 mb-3">
          <MapTrifold size={20} weight="fill" />
          <div className="label-mono">Cómo trabajamos juntos</div>
        </div>
        <ol className="list-decimal pl-5 space-y-2 text-sm leading-relaxed">
          <li>La <strong>Brújula</strong> responde <em>¿voy por el camino correcto?</em>.</li>
          <li>Las <strong>Rutas</strong> responden <em>¿qué hago paso a paso?</em>.</li>
          <li><strong>Hoy</strong> responde <em>¿qué hago hoy?</em>.</li>
          <li>Y <strong>Ruta</strong> (esta pantalla) responde tus dudas puntuales cuando las necesites.</li>
        </ol>
      </div>
    </div>
  );
}
